import api from '@/api';
import { PageResult } from '@/core/request/PageResult';

import { API_BASE_URL } from '..';

import {
  ForecastPayable,
  ForecastPayableCreateRequest,
  ForecastPayableGenerateAccountRequest,
  ForecastPayableUpdateRequest,
  ListForecastPayableQuery,
} from './ForecastPayable.types';

const baseUrl = `${API_BASE_URL}/ForecastPayable`;

export async function listForecastPayable(params?: ListForecastPayableQuery) {
  const result = (await api.get(baseUrl, params)) as unknown;

  return result as PageResult<ForecastPayable>;
}

export async function createForecastPayable(
  obj: ForecastPayableCreateRequest,
): Promise<ForecastPayable> {
  const result = (await api.post(`${baseUrl}`, obj, null)) as unknown;

  return result as ForecastPayable;
}

export async function detailForecastPayable(
  id: number,
): Promise<ForecastPayable> {
  const result = (await api.get(`${baseUrl}/${id}`, {})) as unknown;
  return result as ForecastPayable;
}

export async function updateForecastPayable(
  obj: ForecastPayableUpdateRequest,
): Promise<ForecastPayable> {
  const result = (await api.put(`${baseUrl}/${obj.id}`, obj, null)) as unknown;
  return result as ForecastPayable;
}

export async function deleteForecastPayable(
  id: number,
): Promise<ForecastPayable> {
  const result = (await api.remove(`${baseUrl}/${id}`, {}, null)) as unknown;
  return result as ForecastPayable;
}

export async function createAccountInForecastPayable({
  forecastPayableId,
  ...obj
}: ForecastPayableGenerateAccountRequest) {
  const result = (await api.post(
    `${baseUrl}/${forecastPayableId}/generate-account-payable`,
    obj,
    null,
  )) as unknown;

  return result;
}
